// @flow

import operator from './operator'

export default operator.reducers
